import type { UUID } from '@/types/Id'

export const toggleVisibleMemberIds = (
  selectedIds: UUID[],
  visibleIds: UUID[],
): UUID[] => {
  if (visibleIds.length === 0) {
    return selectedIds
  }

  const selected = new Set(selectedIds)
  const allVisibleSelected = visibleIds.every((id) => selected.has(id))
  if (allVisibleSelected) {
    const visible = new Set(visibleIds)
    return selectedIds.filter((id) => !visible.has(id))
  }

  for (const id of visibleIds) {
    selected.add(id)
  }
  return [...selected]
}
